export default "__VITE_ASSET__e669c4c2__"